
import '../../theme/amchi-theme.css'
import './Login.css'
import { useNavigate } from 'react-router-dom'
import { Footer } from '../Footer/Footer';
import { useAuthDispatch, useAuthState } from '../../Helper/Context/context';
import { useEffect, useState } from 'react';
import { loginUser } from '../../Helper/Context/action';
import moment from 'moment';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import i18n from '../../Helper/Langauges/LangMain';
import { LanguageDDL } from '../../Components/CommonDDL/LanguageDDL';


export const Login = () => {

    const navigate = useNavigate()

    // useTranslation (not the bare `t`) so the page re-renders on a language switch
    const { t } = useTranslation()

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: 'Marathi'
    })

    // keeps the page in sync with the stored choice, including after a reload
    useEffect(() => {
        if (Language.Label && i18n.language !== Language.Label) {
            i18n.changeLanguage(Language.Label)
        }
    }, [Language.Label])

    const dispatch = useAuthDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [userName, setuserName] = useState("")
    const [password, setpassword] = useState("")
    const [loading, setloading] = useState(false)
    const [Validationerror, setValidationerror] = useState(false)
    const [Loginmessage, setLoginmessage] = useState('')

    const handleSubmit = async (e) => {
        setLoginmessage('')
        e.preventDefault()
        if (userName !== '' && password !== '') {
            try {
                let response = await loginUser(dispatch, { userName, password, setloading, handleRollIdWiseDashboard, handleErrorIdWiseDashboard, setLoginmessage });
                if (!response) return;
                // navigate('/dashboard');

            } catch (error) {
                console.log(error);
            }
            setValidationerror(false)
        } else {
            setValidationerror(true)
            if (userName == '') {
                document.getElementById('Username').classList.add('validation-error')
            } else {
                document.getElementById('Username').classList.remove('validation-error')
            }

            if (password == '') {
                document.getElementById('Password').classList.add('validation-error')
            } else {
                document.getElementById('Password').classList.remove('validation-error')
            }
        }

    }
    const handleRollIdWiseDashboard = (data) => {
        // console.log(data.m_RoleID)
        if (data.m_RoleID == 2 || data.m_RoleID == 3 || data.m_RoleID == 4) {
            navigate(`/DirectorDashboard`)
        } else if (data.m_RoleID == 5 || data.m_RoleID == 6) {
            navigate(`/MainDashboard`)
        }
        else if (data.m_RoleID == 7) {
            navigate(`/RegistrationDashboard?UserName=NewUser`)
            // navigate(`/DirectorDashboard`)
        } else if (data.m_RoleID == 1) {
            navigate(`/DesignationMaster`)
        }
    }
    const handleErrorIdWiseDashboard = (data) => {
        setLoginmessage(data)
    }

    const showPass = () => {
        var x = document.getElementById("Password");
        var y = document.getElementById("eye");
        if (x.type === "password") {
            x.type = "text";
            y.className = "fa fa-eye-slash";
        } else {
            x.type = "password";
            y.className = "fa fa-eye";
        }
    }

    const handleDownloadAPk = () => {
        window.open('https://files.catbox.moe/0imud3.apk')
    }

    return (
        <div className="am-page">

            {/* soft decorative background */}
            <div className="am-decor" aria-hidden="true">
                <span className="am-blob am-blob-1"></span>
                <span className="am-blob am-blob-2"></span>
                <span className="am-blob am-blob-3"></span>
            </div>

            {/* ---------------- masthead ---------------- */}
            <header className="am-topbar">
                <div className="am-shell am-topbar-inner">
                    <img className="am-topbar-logo" src="assets/img/Login/nhm-logo.png" alt="सार्वजनिक आरोग्य विभाग" />

                    <div className="am-topbar-text">
                        <span className="am-eyebrow">{t('Home.PublicGrievanceApplication')}</span>
                        <h1 className="am-topbar-title">{t('Home.SchemeName')}</h1>
                        <p className="am-topbar-sub">
                            <span>{t('Home.Department')}</span> &nbsp;·&nbsp; {t('Home.Office')}
                        </p>
                    </div>

                    <img className="am-topbar-logo" src="assets/img/Login/nhm-logo-nation.png" alt="National Health Mission Maharashtra" />

                    <div className="am-topbar-tools">
                        <i className="fa-solid fa-language am-lang-ico" aria-hidden="true"></i>
                        <span className="am-lang">
                            <LanguageDDL
                                Language={Language}
                                setLanguage={setLanguage}
                            />
                        </span>
                    </div>
                </div>
            </header>

            <main className="am-shell">

                {/* ---------------- hero ---------------- */}
                <section className="am-hero">
                    <div className="am-hero-copy am-rise am-rise-2">
                        <span className="am-pill"><i className="fa-solid fa-ribbon"></i> {t('Home.SaveTheGirlChild')}</span>

                        <h2 className="am-hero-title">
                            {t('Home.HeroTitle')} <span>{t('Home.HeroTitleAccent')}</span>
                        </h2>

                        <p className="am-hero-lead">
                            <strong>{t('Home.PCPNDT')}</strong> {t('Home.HeroLead')}
                        </p>

                        <div className="am-helplines">
                            <a className="am-helpline" href="tel:18002334475">
                                <span className="am-helpline-ico"><i className="fa-solid fa-phone-volume"></i></span>
                                <span>
                                    <small>{t('Home.TollFreeNumber')}</small>
                                    <b>1800 233 4475</b>
                                </span>
                            </a>

                            <a className="am-helpline" href="tel:104">
                                <span className="am-helpline-ico"><i className="fa-solid fa-headset"></i></span>
                                <span>
                                    <small>{t('Home.HealthHelpline')}</small>
                                    <b>104</b>
                                </span>
                            </a>
                        </div>

                        <button type="button" className="am-ghost-btn" onClick={() => handleDownloadAPk()}>
                            <i className="fa-solid fa-mobile-screen-button"></i> {t('Home.DownloadAndroidApp')}
                        </button>
                    </div>

                    <figure className="am-hero-art am-rise">
                        <img src="assets/img/Login/with_mulgi.jpg" alt="बेटी बचाओ – Save the Girl Child" />
                        <figcaption className="am-hero-badge">
                            <i className="fa-solid fa-shield-heart"></i> {t('Home.GovernmentInitiative')}
                        </figcaption>
                    </figure>
                </section>

                {/* ---------------- trust strip ---------------- */}
                <section className="am-trust am-rise am-rise-3">
                    <div className="am-trust-item">
                        <i className="fa-solid fa-user-shield"></i>
                        <span>
                            <b>{t('Home.Privacy')}</b>
                            <span>{t('Home.PrivacyNote')}</span>
                        </span>
                    </div>
                    <div className="am-trust-item">
                        <i className="fa-solid fa-bolt"></i>
                        <span>
                            <b>{t('Home.QuickAction')}</b>
                            <span>{t('Home.QuickActionNote')}</span>
                        </span>
                    </div>
                    <div className="am-trust-item">
                        <i className="fa-solid fa-list-check"></i>
                        <span>
                            <b>{t('Home.FollowUp')}</b>
                            <span>{t('Home.FollowUpNote')}</span>
                        </span>
                    </div>
                </section>

                {/* ---------------- body: actions + login ---------------- */}
                <div className="am-body">

                    <section className="am-card am-notices am-rise am-rise-3" style={{ marginTop: 0 }}>
                        <h3 className="am-section-title">
                            <i className="fa-solid fa-file-circle-plus"></i> {t('GrievanceRegistration.GrievanceRegistration')}
                        </h3>
                        <p className="am-section-note">{t('Home.ChooseOption')}</p>

                        <div className="am-actions">
                            <button type="button" className="am-action" onClick={() => navigate('/WithRegistration')}>
                                <span className="am-action-ico"><i className="fa-solid fa-user-plus"></i></span>
                                <b>{t('Home.WithCitizenRegistration')}</b>
                                <span>{t('Home.WithCitizenRegistrationNote')}</span>
                                <span className="am-action-more">{t('Home.Proceed')} <i className="fa-solid fa-arrow-right"></i></span>
                            </button>

                            <button type="button" className="am-action am-action--alt" onClick={() => navigate('/WithoutRegistration')}>
                                <span className="am-action-ico"><i className="fa-solid fa-pen-to-square"></i></span>
                                <b>{t('Home.WithoutCitizenRegistration')}</b>
                                <span>{t('Home.WithoutCitizenRegistrationNote')}</span>
                                <span className="am-action-more">{t('Home.Proceed')} <i className="fa-solid fa-arrow-right"></i></span>
                            </button>
                        </div>

                        <span className="am-manual" onClick={() => window.open('/assets/docs/Usermanual Grievance Submit.pdf')}>
                            <i className="fa-solid fa-book-open"></i> {t('Home.UserManual')}
                        </span>
                    </section>

                    {/* login card */}
                    <section className="am-card am-login am-login-col am-rise am-rise-2">
                        <div className="am-login-head">
                            <span className="am-login-avatar"><i className="fa-solid fa-user-lock"></i></span>
                            <h2>{t('Home.Login')}</h2>
                            <p>{t('Home.LoginSubtitle')}</p>
                        </div>

                        <div className="am-login-form">
                            <form onSubmit={handleSubmit}>
                                <label className="am-label" htmlFor="Username">{t('CitizenRegistration.UserName')}</label>
                                <div className="am-field">
                                    <i className="fa-solid fa-user"></i>
                                    <input
                                        id='Username'
                                        type="text"
                                        placeholder={t('CitizenRegistration.UserName')}
                                        aria-label="Username"
                                        autoComplete="username"
                                        value={userName}
                                        onChange={(e) => setuserName(e.target.value)}
                                    />
                                </div>

                                <label className="am-label" htmlFor="Password">{t('CitizenRegistration.Password')}</label>
                                <div className="am-field">
                                    <i className="fa-solid fa-lock"></i>
                                    <input
                                        id='Password'
                                        type="password"
                                        placeholder={t('CitizenRegistration.Password')}
                                        aria-label="password"
                                        autoComplete="current-password"
                                        value={password}
                                        onChange={(e) => setpassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="am-eye"
                                        aria-label="पासवर्ड दाखवा / लपवा"
                                        onClick={showPass}
                                    >
                                        <i id='eye' className="fa fa-eye"></i>
                                    </button>
                                </div>

                                <button
                                    type="submit"
                                    className="am-submit"
                                    disabled={loading}
                                >
                                    {loading
                                        ? <><i className="fa-solid fa-circle-notch fa-spin"></i> {t('Home.PleaseWait')}</>
                                        : <><i className="fa-solid fa-right-to-bracket"></i> {t('Home.LoginButton')}</>}
                                </button>
                            </form>

                            {Validationerror && userName === '' && password === '' &&
                                <div className="am-form-msg">
                                    <i className="fa-solid fa-circle-exclamation"></i>
                                    <span>{t('Home.FillUserNameAndPassword')}</span>
                                </div>
                            }

                            {Loginmessage &&
                                <div className="am-form-msg">
                                    <i className="fa-solid fa-circle-exclamation"></i>
                                    <span>{Loginmessage}</span>
                                </div>
                            }

                            <div className="am-divider">{t('Home.Or')}</div>

                            <p className="am-section-note" style={{ marginBottom: 0, textAlign: 'center' }}>
                                {t('Home.NoLoginNeededA')} <b style={{ color: 'var(--am-rose)' }}>{t('GrievanceRegistration.GrievanceRegistration')}</b> {t('Home.NoLoginNeededB')}
                            </p>
                        </div>
                    </section>
                </div>

                {/* ---------------- notices ---------------- */}
                <section className="am-card am-notices am-rise am-rise-4">
                    <h3 className="am-section-title"><i className="fa-solid fa-circle-info"></i> {t('Home.Notice')}</h3>

                    <div className="am-notice">
                        <span className="am-notice-num">1</span>
                        <p>
                            {t('Home.NoticeGrievanceQuery')} <a href="tel:02026058476">020 2605 8476</a>,
                            &nbsp;{t('Home.NoticeOrEmail')} <a href="mailto:pndt07@gmail.com">pndt07@gmail.com</a>
                        </p>
                    </div>
                </section>

                {/* ---------------- footer ---------------- */}
                <footer className="am-footer">
                    <span>© {moment().format('YYYY')} {t('Home.Department')} · {t('Home.AllRightsReserved')}</span>
                    <a href="http://amchimulgimaha.in" target="_blank" rel="noreferrer">
                        <i className="fa-solid fa-globe"></i> amchimulgimaha.in
                    </a>
                </footer>
            </main>
        </div>
    )
}
